/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import CardsError from './CardsError';

/**
 * CardsError module exports
 */
export { CardsError as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CardsError/index.js